import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, catchError, throwError, map, of } from 'rxjs';
import { OAuthService } from 'angular-oauth2-oidc';
import { ChatbotInteractionResponse } from '../models/chatbot-interaction.model';
import { Chatbot } from '../../../core/models/chatbot.model';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChatbotInteractionService {
  private http = inject(HttpClient);
  private oauthService = inject(OAuthService, { optional: true });
  
  private readonly baseUrl = environment.userManagementApiUrl;
  private readonly chatbotsEndpoint = `${this.baseUrl}/chatbot/by-user`;

  /**
   * Get chatbots for the authenticated user
   */
  getChatbotsByUser(): Observable<Chatbot[]> {
    if (environment.mockAuth) {
      return this.getMockChatbots();
    }
    
    const headers = this.getAuthHeaders();
    
    return this.http.get<ChatbotInteractionResponse>(this.chatbotsEndpoint, { headers }).pipe(
      map(response => response.user.chatbots),
      catchError(error => {
        return throwError(() => error);
      })
    );
  }

  /**
   * Get mock chatbots for testing
   */
  private getMockChatbots(): Observable<Chatbot[]> {
    const mockChatbots: Chatbot[] = [
      {
        chatbotId: 1,
        name: 'Test Chatbot 1',
        description: 'A test chatbot for local development',
        code: 'test-bot-1',
        isActive: true,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        createdBy: 'mock-user',
        updatedBy: null,
        endpointToSend: '',
        endpointToReceive: '',
        credentials: null,
        typeId: 1,
        conversationVisualizerCredentials: null,
        conversationVisualizerEndpoint: null,
      },
      {
        chatbotId: 2,
        name: 'Test Chatbot 2',
        description: 'Another test chatbot',
        code: 'test-bot-2',
        isActive: true,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        createdBy: 'mock-user',
        updatedBy: null,
        endpointToSend: '',
        endpointToReceive: '',
        credentials: null,
        typeId: 1,
        conversationVisualizerCredentials: null,
        conversationVisualizerEndpoint: null,
      },
    ];
    return of(mockChatbots);
  }

  /**
   * Get authentication headers with JWT token
   */
  private getAuthHeaders(): HttpHeaders {
    const token = this.oauthService?.getAccessToken();
    return new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });
  }
}

